<template>
  <div class="shareBtns">    
    <div @click="showShareMenu" :class="['shareOpener',{off:isMenuOn}]">
        <a><i class="fal fa-share-alt"></i>
        {{localize('Share')}}
        </a>
    </div>  
    <div :class="['sharemenu',{on:isMenuOn}]">
      <ul>
        <li :class="{on:isMenuOn}">
            <a :href="getFacebookShareLink()" target="_blank">
                <i class="fab fa-facebook-square"></i><span>Facebook</span>
            </a>
        </li>
        <li :class="{on:isMenuOn}">
            <a :href="getTwitterShareLink()" target="_blank">
                <i class="fab fa-twitter"></i><span>Twitter</span>
            </a>
        </li>
        <li :class="{on:isMenuOn}">
            <a :href="getLinkedInShareLink()" target="_blank">
                <i class="fab fa-linkedin"></i><span>LinkedIn</span>
            </a>
        </li>
      </ul>
    </div>    
   </div>
</template>


<script>
export default {
  props: 
    {
        isMenuOn: {
        type: Boolean,
        default: false
        }
    },
    methods:
    {
        showShareMenu()
        {
            var vm = this;
            vm.isMenuOn=true;
            setTimeout(
            function() {
                vm.isMenuOn=false;
            }.bind(this),3500);
        },
        getFacebookShareLink(){
            return "https://www.facebook.com/sharer/sharer.php?u="+window.location.href;
        },
        getTwitterShareLink(){
            return "https://twitter.com/intent/tweet?url="+window.location.href;
        },
        getLinkedInShareLink(){
            return "https://www.linkedin.com/shareArticle?mini=true&url="+window.location.href;
        }
    },  
};
</script>

<style scoped>
    .shareBtns{clear: both;margin-bottom: 60px;position: relative;}
    .shareOpener
    {
        position:absolute;
        top: 20px;
        left: 0px;
        cursor: pointer;
        float: left;
    }
    .shareOpener a
    {
        font-weight: 400 !important;
    }
    .shareOpener.off
    {
        display:none;
    }
    .shareOpener a{color:#000;}
    .shareOpener a i{padding-right:10px;}


    .sharemenu
    {
        position:absolute;
        top: 0px;
        left: 0px;
        float: left;
        pointer-events: none;
    }
    .sharemenu.on
    {
        display: block;
        pointer-events: all;
    }
    .sharemenu ul
    {
        padding: 0px 0px;
        float: left;
        list-style: none;
    }

    .sharemenu ul li:nth-child(1){transition-delay: 0.1s;}
    .sharemenu ul li:nth-child(2){transition-delay: 0.15s;}
    .sharemenu ul li:nth-child(3){transition-delay: 0.2s;}

    .sharemenu ul li
    {
        font-size:16px;
        float:left;
        padding-right:20px;        
        opacity: 0;
        transform: translateX(20px);
        transition: all ease-in-out 0.3s;
    }
    .sharemenu ul li.on
    {
        transform: translateX(0px);
        opacity: 1;
    }    

    .sharemenu ul li a
    {
        cursor:pointer;
        font-size:16px;
        color:#6d7379;
    }
    .sharemenu ul li a i
    {
        font-size: 24px;
        padding-right: 8px;
        position: relative;
        top:2px;
    }

    @media (hover: hover) {
        .shareOpener a:hover{
            color:#159df3;
        }
        .sharemenu ul li a:hover{
            color:#159df3;
        }
    }

    @media screen and (max-width: 815px) {
        .sharemenu ul li a
        {
            cursor:pointer;
            font-size:14px;
            color:#6d7379;
        }

    }

</style>

<!--
<style lang="stylus" scoped>
    .shareLabel1
        display none
    .shareLabel2
        position relative 
        top 4px

    .shareBtns
        padding-top 0px
        margin-bottom 70px
        background-color #fff
        color #6d7379
        padding-bottom 30px

        ul
            padding 0px 0px
            float left
            list-style none
            li
                display table-cell
                vertical-align middle
                font-size 16px
                float left
                padding-right 20px
                a
                    cursor pointer
                    font-size 16px
                    @media screen and (max-width:815px)
                        font-size 14px
                    color #6d7379
                    &:hover
                        color #159df3
                    i
                        font-size 24px
                        padding-right 8px
                        position relative
                        top 2px

    @media screen and (max-width:815px)
        .shareLabel1
            font-weight 400
            display block
            clear both
            position relative 
            top 12px
            font-size 14px
        .shareLabel2
            display  none
        ul
            list-style none
            li
                padding-right 20px
                a
                    cursor pointer
                    font-size 14px

</style>
-->
